import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-6">
            <Link to="/register" className="text-primary-600 hover:text-primary-700">
              ← Back to Registration
            </Link>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms and Conditions of Use</h1>
          <p className="text-sm text-gray-500 mb-8">Last Updated: December 6, 2025</p>

          <div className="prose max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By creating an account, accessing, or using RideConnect ("the Service"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree to these Terms, you may not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
              <p className="text-gray-700 mb-4">
                RideConnect is a social platform that connects cyclists, facilitates group rides, and provides a loyalty rewards program in partnership with participating bicycle stores. The Service includes:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Ride organization and participation</li>
                <li>Social features (friends, messaging, comments)</li>
                <li>Loyalty points and rewards program</li>
                <li>News and promotional content</li>
                <li>Community engagement features</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
              <p className="text-gray-700 mb-4">
                You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. User Conduct</h2>
              <p className="text-gray-700 mb-4">
                You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Transmit any harmful or malicious code</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Post false or misleading information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4.1. Account Abuse and Suspension</h2>
              <p className="text-gray-700 mb-4">
                RideConnect reserves the right to suspend or terminate user accounts that engage in harmful, abusive, or unintended behavior, including but not limited to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Attempting to exploit security vulnerabilities (e.g., cross-site scripting, code injection)</li>
                <li>Using the platform to send malicious content or spam</li>
                <li>Harassing, threatening, or abusing other users</li>
                <li>Violating community guidelines or terms of service</li>
                <li>Engaging in fraudulent activities</li>
                <li>Attempting to manipulate or abuse the loyalty program</li>
                <li>Any other behavior that compromises platform security or user safety</li>
              </ul>
              <p className="text-gray-700 mb-4 mt-4">
                <strong>Account Suspension:</strong> If your account is suspended, you will receive a message explaining the suspension when attempting to log in. Suspended accounts retain all data but cannot access the platform until the suspension is lifted by an administrator. You may contact support to appeal a suspension.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>Account Termination:</strong> In cases of severe violations, RideConnect reserves the right to permanently terminate accounts. Terminated accounts may have their data removed in accordance with our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Loyalty Program</h2>
              <p className="text-gray-700 mb-4">
                The loyalty points program is subject to the terms and conditions set forth by participating stores. Points may be awarded, redeemed, or modified at the discretion of the service provider.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                RideConnect and its partners are not liable for any injuries, damages, or losses that may occur during organized rides or use of the Service. Participation in rides is at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Changes to Terms</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the modified Terms.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
